import config from './config.js'
import axios from 'axios'
import util from '../util.js'
import { handle401Error, create401Response, isPublicPath } from '../util/authHelper.js'

export default {
    request(url, data = {}, method = "GET", extraHeaders = {}) {
        let lang = util.getCache('lang', config.default_lang);
        if(lang === 'zh' || lang === 'zh_Hant'){
            lang = 'zh_CN';
        }
        let token = util.getCache('token');

        // 从环境变量读取配置，提供默认值
        const device = parseInt(process.env.VUE_APP_CLIENT_DEVICE || '2', 10); // PC端默认设备类型为2
        const timeout = parseInt(process.env.VUE_APP_API_TIMEOUT || '10000', 10); // 默认超时10秒
        let timestamp = Math.floor(Date.now() / 1000);
        
        // API请求日志已关闭
        
        return new Promise((resolve, reject) => {
            axios({
                method: method,
                url: config.BASE_URL + '/' + url,
                data: data,
                params:method === "GET" ? data : {},
                timeout: timeout,
                headers: {
                    "Accept-Language": lang,
                    "Authorization": "Bearer " + token,
                    "Client-Device": device,
                    "Timestamp": timestamp,
                    ...extraHeaders,
                },
                withCredentials: false,
            }).then(function (response) {
                let data = response.data
                
                // API响应日志已关闭

                if (response.data.code === 1001 || response.data.code === 500) {
                    // 服务器错误日志已关闭
                    return reject(new Error('服务器错误: ' + (response.data.message || 'server error')))
                }
                if (response.data.code === 401) {//未登录
                    // 使用统一的 401 错误处理
                    const currentPath = window.location.pathname;
                    const shouldSilentHandle = handle401Error(currentPath);
                    
                    if (shouldSilentHandle) {
                        // 在公开页面，静默处理401状态
                        return resolve(create401Response());
                    }
                    
                    // 在需要登录的页面，抛出错误
                    return reject(new Error('API错误 401: 使用者異常或未登錄，請重新登入'))
                }
                return resolve(data)
            }).catch(function (error) {
                // API请求失败日志已关闭
                
                // 正确处理网络错误
                if (error.response && error.response.status) {
                    // 服务器返回了错误状态码
                    const status = error.response.status;
                    const message = error.response.data && error.response.data.message ? error.response.data.message : error.message;
                    
                    // 特殊处理401错误
                    if (status === 401) {
                        // 使用统一的 401 错误处理
                        const currentPath = window.location.pathname;
                        const shouldSilentHandle = handle401Error(currentPath);
                        
                        if (shouldSilentHandle) {
                            // 在公开页面，静默处理401状态
                            return resolve(create401Response());
                        }
                        
                        // 在需要登录的页面，抛出错误
                        return reject(new Error(`API错误 ${status}: ${message}`))
                    }
                    
                    return reject(new Error(`API错误 ${status}: ${message}`))
                } else if (error.request) {
                    // 请求被发出但没有收到响应
                    return reject(new Error('网络连接失败，请检查网络连接'))
                } else {
                    // 其他错误
                    return reject(new Error(error.message || 'API请求失败'))
                }
            })
        });
    },
    getBaseUrl() {
        return config.BASE_URL;
    },
}
